import script from "./UScroll.vue?vue&type=script&setup=true&lang=js"
export * from "./UScroll.vue?vue&type=script&setup=true&lang=js"

import "./UScroll.vue?vue&type=style&index=0&id=0a791d38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a791d38"]])

export default __exports__